import React from 'react'

import Accordion, { AccordionProps } from './components/accordion.component'
import FloatingAccordion from './components/floating-accordion.component'

type ComponentProps = Pick<AccordionProps, Exclude<keyof AccordionProps, 'toggleExpanded' | 'isExpanded'>>

interface AccordionStateProps extends ComponentProps {
  id?: string | number
  toggle?: (id: string | number, isExpanded: boolean) => void
  isExpanded?: boolean
  type?: string
  isDisabled?: boolean
}

const FilterAccordion: React.FC<AccordionStateProps> = ({
  id = '',
  isExpanded,
  toggle,
  type = 'normal',
  isDisabled,
  ...props
}) => {
  const [isStateExpanded, updateStateExpanded] = React.useState(!!isExpanded)

  React.useEffect(() => {
    updateStateExpanded(!!isExpanded && !isDisabled)
  }, [isExpanded, isDisabled])

  const toggleAccordion = () => {
    toggle ? toggle(id, !isStateExpanded) : updateStateExpanded(!isStateExpanded)
  }

  return type === 'normal' ? (
    <Accordion {...props} isExpanded={isStateExpanded} toggleExpanded={toggleAccordion} isDisabled={isDisabled} />
  ) : (
    <FloatingAccordion {...props} isExpanded={isStateExpanded} toggleExpanded={toggleAccordion} />
  )
}

export default FilterAccordion
